/**
 * The header that carries the caller's Google ID token to the portal's
 * `/api/control/*` backend, which forwards it to Control.
 *
 * It was `x-google-id-token`, and in production it never arrived: Google's
 * front end (in front of every Cloud Run service) strips incoming request
 * headers with the reserved `X-Google-` prefix. Locally nothing sits in
 * between, so every test and `yarn start` passed while My requests, Submit on
 * New environment and the run panels all got `missing … token` in production.
 * Must match CALLER_ID_TOKEN_HEADER in the backend's modules/control/router.ts,
 * and must never start with `x-google-`.
 */
export const CALLER_ID_TOKEN_HEADER = 'x-caller-id-token';
